import { render } from "./InvoiceIcon.vue?vue&type=template&id=84176c08&scoped=true"
import script from "./InvoiceIcon.vue?vue&type=script&lang=js"
export * from "./InvoiceIcon.vue?vue&type=script&lang=js"

import "./InvoiceIcon.vue?vue&type=style&index=0&id=84176c08&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-84176c08"

export default script